const authorityList = () => import('@/views/main/authority/list/list.vue')
export default {
  path: '/main/authority/list',
  name: 'authorityList',
  component: authorityList,
  children: []
}
